import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-poll-show-layout',
  templateUrl: './poll-show-layout.component.html',
  styleUrls: ['./poll-show-layout.component.css']
})
export class PollShowLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
